import { render } from "./Pagination.vue?vue&type=template&id=522639a8&bindings={\"current\":\"props\",\"paginateBy\":\"props\",\"total\":\"props\",\"compact\":\"props\",\"pages\":\"options\",\"maxPage\":\"options\",\"selectPage\":\"options\"}"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"
script.render = render

export default script